import { z } from 'zod';
/**
 * Shape of `GET /api/brand`. Unauthenticated — the login doors render this
 * before any session exists — and read-only: nothing in the app can PATCH
 * it, because neither half is a database row. See apps/api/src/env.ts.
 *
 * Two independent concepts, not one:
 *   product  the software's own name — replaces "Perla"/"PerlaProp" mentions.
 *   company  the property-management agency running this instance — shown
 *            only in the header's brand slot. Already resolved server-side
 *            to fall back to `product.name` when unconfigured, so this is
 *            never an empty string.
 *
 * The logo image itself is not part of this response — it's a fixed bundled
 * file (`apps/web/public/branding/company-logo.png`, see BrandMark.tsx), not
 * a config value, so there is nothing here for it to be.
 */
export const brandConfigSchema = z.object({
    product: z.object({ name: z.string() }),
    company: z.object({ name: z.string() }),
});
//# sourceMappingURL=brand.js.map